import { Button } from '@mui/material'
import React from 'react'
// import { navigationUrl } from '../../../../utils/constants/links';

const WorkSpaceNavigateInvoice = ({ rowData }) => {
    const navigationUrl = process.env.REACT_APP_PHP_URL;
  function encodeBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  const createWorkSpaceLink = () => {
    const userProfile = JSON.parse(localStorage.getItem("cred"));
    const hashId = userProfile?.hashID
    const url = `${navigationUrl}/login/auth/${hashId}`;
    const myworkspaceWindow = window.open(url, '_blank', 'width=1,height=1,left=-1000,top=-1000');


    setTimeout(() => {
      myworkspaceWindow.close()
      const invoiceWindow = window.open(`${navigationUrl}/invoice/print?id1=${encodeBase64(rowData.admnNo)}&id2=${encodeBase64(rowData.invoice_date)}&id3=${encodeBase64(rowData.is_currency)}&id4=${encodeBase64(rowData.invoice_accountant_verification)}&id5=${encodeBase64(rowData.invoice_accountant_verified_on ? rowData.invoice_accountant_verified_on : '')}`, '_blank',);
    }, 2000)
  }
  const clickHandler = () => {
    createWorkSpaceLink()
  }
  return (
    <Button onClick={clickHandler}>Invoice</Button>
  )
}

export default WorkSpaceNavigateInvoice